import bookStoreReducer from "./books/reducer";
import filterReducer from "./filters/reducer";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
  bookStore: bookStoreReducer,
  filters: filterReducer,
});

export default rootReducer;
